import Vue from 'vue'
import Router from 'vue-router'

import LayoutFirst from '@/views/layout/LayoutFirst'
import LayoutSecond from '@/views/layout/LayoutSecond'
import LayoutThree from '@/views/layout/LayoutThree'
import LayoutFour from '@/views/layout/LayoutFour'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '',
      component: LayoutFirst,
      children: [
        {
          path: '/history',
          component: () => import('@/views/history/index'),
          name: 'History',
          meta: {
            title: 'history'
          }
        },
        {
          path: 'family/list',
          component: () => import('@/views/family/list'),
          name: 'familyList',
          meta: {
            title: 'myfamily'
          }
        },
        {
          path: 'MyInfo',
          component: () => import('@/views/user/my'),
          name: 'MyInfo',
          meta: {
            title: 'setting'
          }
        },
        {
          path: '/home',
          component: () => import('@/views/home/index'),
          name: 'Home',
          meta: {
            title: 'homepage'
          }
        },
        {
          path: 'sugar/statistic',
          component: () => import('@/views/sugar/statistic/index'),
          name: 'SugarStatistic',
          meta: {
            title: 'statistics'
          }
        },
        {
          path: 'sugar/history',
          component: () => import('@/views/sugar/history/index'),
          name: 'SugarHistory',
          meta: {
            title: 'history'
          }
        },
        {
          path: 'health',
          component: () => import('@/views/health/index'),
          name: 'Health',
          meta: {
            title: '数据'
          }
        },
        {
          path: 'mall',
          component: () => import('@/views/mall/index'),
          name: 'Mall',
          meta: {
            title: '商城'
          }
        },
        {
          path: 'mine',
          component: () => import('@/views/mine/index'),
          name: 'Mine',
          meta: {
            title: '个人'
          }
        },
        {
          path: 'friend',
          component: () => import('@/views/chat/friend'),
          name: 'Friend',
          meta: {
            title: '咨询'
          }
        }

      ]
    },
    {
      path: '',
      name: 'second',
      component: LayoutSecond,
      children: [
        {
          path: '/open',
          component: () => import('@/views/setting/privacy'),
          name: 'open',
          meta: {
            title: 'privacypolicy'
          }
        },
        {
          path: '/register',
          component: () => import('@/views/register/index'),
          name: 'register',
          meta: {
            title: 'register'
          }
        },
        {
          path: '/history/second',
          component: () => import('@/views/history/history'),
          name: 'History',
          meta: {
            title: 'history'
          }
        },
        {
          path: 'analysis/result',
          component: () => import('@/views/history/result'),
          name: 'AnalysisResult',
          meta: {
            title: 'analysisreport'
          }
        },
        {
          path: 'heart/pic',
          component: () => import('@/views/history/heartPic'),
          name: 'HeartPic',
          meta: {
            title: 'electrocardiogram'
          }
        },
        {
          path: 'test/result',
          component: () => import('@/views/history/detail'),
          name: 'TestResult',
          meta: {
            title: 'measurement'
          }
        },
        {
          path: 'setting/doc',
          component: () => import('@/views/setting/doc'),
          name: 'Document',
          meta: {
            title: 'directionforuse'
          }
        },
        {
          path: 'setting/help',
          component: () => import('@/views/setting/help'),
          name: 'UseHelp',
          meta: {
            title: 'help'
          }
        },
        {
          path: 'setting/privacy',
          component: () => import('@/views/setting/privacy'),
          name: 'PrivacyPolicy',
          meta: {
            title: 'privacypolicy'
          }
        },
        {
          path: 'family/nav',
          component: () => import('@/views/family/addNav'),
          name: 'addNav',
          meta: {
            title: 'addfamily'
          }
        },
        {
          path: 'family/bind',
          component: () => import('@/views/family/bind'),
          name: 'familyBind',
          meta: {
            title: 'bindaccount'
          }
        },
        {
          path: 'family/add',
          component: () => import('@/views/family/add'),
          name: 'familyAdd',
          meta: {
            title: 'addfamily'
          }
        },
        {
          path: 'near/test/result',
          component: () => import('@/views/test/result/index'),
          name: 'NearTestResult',
          meta: {
            title: 'measurement'
          }
        },
        {
          path: 'bind/code',
          component: () => import('@/views/bind/code'),
          name: 'BindCode',
          meta: {
            title: 'putcode'
          }
        },
        {
          path: 'edit/user/info',
          component: () => import('@/views/user/index'),
          name: 'EditUserInfo',
          meta: {
            title: 'improveprofile'
          }
        },
        {
          path: 'edit/user/set',
          component: () => import('@/views/user/set'),
          name: 'EditUserSet',
          meta: {
            title: 'personaldetails'
          }
        },
        {
          path: 'edit/user/phone',
          component: () => import('@/views/user/phone'),
          name: 'EditUserPhone',
          meta: {
            title: 'changephone'
          }
        },
        {
          path: 'sugar/set',
          component: () => import('@/views/sugar/set'),
          name: 'SugarSet',
          meta: {
            title: 'setting'
          }
        },
        {
          path: 'chat',
          component: () => import('@/views/chat/index'),
          name: 'Chat',
          meta: {
            title: '咨询'
          }
        },
        {
          path: 'information',
          component: () => import(`@/views/home/information`),
          name: 'Information',
          meta: {
            title: '资讯'
          }
        },
        // 健康数据
        {
          path: 'health/reports',
          component: () => import('@/views/health/reports'),
          name: 'HealthReports',
          meta: {
            title: '健康报告'
          }
        },
        // 健康数据
        {
          path: 'health/report',
          component: () => import('@/views/health/report'),
          name: 'HealthReport',
          meta: {
            title: '健康报告'
          }
        },
        {
          path: 'health/warning',
          component: () => import('@/views/health/warning'),
          name: 'warning',
          meta: {
            title: '健康预警'
          }
        },
        {
          path: 'health/suggest',
          component: () => import('@/views/health/suggest'),
          name: 'suggest',
          meta: {
            title: '健康建议'
          }
        },
        {
          path: 'health/bp',
          component: () => import('@/views/health/item/bp'),
          name: 'Bp',
          meta: {
            title: '血压'
          }
        },
        {
          path: 'health/bs',
          component: () => import('@/views/health/item/bs'),
          name: 'Bs',
          meta: {
            title: '血糖'
          }
        },
        {
          path: 'health/hb',
          component: () => import('@/views/health/item/hb'),
          name: 'Hb',
          meta: {
            title: '心率'
          }
        },
        {
          path: 'health/bo',
          component: () => import('@/views/health/item/bo'),
          name: 'Bo',
          meta: {
            title: '血氧'
          }
        },
        {
          path: 'health/step',
          component: () => import('@/views/health/item/step'),
          name: 'Step',
          meta: {
            title: '步数'
          }
        },
        {
          path: 'health/hrv',
          component: () => import('@/views/health/item/hrv'),
          name: 'Hrv',
          meta: {
            title: 'HRV心脏指数'
          }
        },
        {
          path: 'health/pause',
          component: () => import('@/views/health/item/pause'),
          name: 'Pause',
          meta: {
            title: '呼吸暂停次数'
          }
        },
        {
          path: 'goods',
          component: () => import('@/views/goods/detail'),
          name: 'Goods',
          meta: {
            title: '商品详情'
          }
        },
        {
          path: 'order/submitOrder',
          component: () => import('@/views/order/submitOrder'),
          name: 'submitOrder',
          meta: {
            title: '提交订单'
          }
        },
        {
          path: 'order/orderList',
          component: () => import('@/views/order/orderList'),
          name: 'orderList',
          meta: {
            title: '订单列表'
          }
        },
        {
          path: 'mine/info',
          component: () => import('@/views/mine/info'),
          name: 'MineInfo',
          meta: {
            title: '个人信息'
          }
        },
        {
          path: 'logged/xy',
          component: () => import('@/views/logged/xy'),
          name: 'xy',
          meta: {
            title: '手动输入'
          }
        }
      ]
    },
    {
      path: '/login',
      component: () => import('@/views/login/index'),
      name: 'Login',
      meta: {
        title: '登录'
      }
    },
    {
      path: '',
      component: LayoutThree,
      children: [
        {
          path: '/helpCenter',
          component: () => import('@/views/help/index'),
          name: 'HelpCenter',
          meta: {
            title: 'help'
          }
        },
        {
          path: '/helpContent',
          component: () => import('@/views/help/pdf'),
          name: 'helpContent',
          meta: {
            title: 'help'
          }
        },
        {
          path: '/download',
          component: () => import('@/views/download/index'),
          name: 'Download',
          meta: {
            title: '下载盖德健康APP'
          }
        }
      ]
    },
    {
      path: '',
      component: LayoutFour,
      children: [
        {
          path: 'bind/phone',
          component: () => import('@/views/bind/phone'),
          name: 'BindPhone',
          meta: {
            title: 'associatedmobile'
          }
        }
      ]
    }
  ]
})
